$shm_hitalama_text $mol_text
